<template>
  <section class="InquiryCondition0014">
    <el-row :gutter="0" class="InquiryConditionHead">
      <router-link to="/sp/0002" class="Router__To__Destination" tabindex="1">
        <i class="el-icon-close" tabindex="1"></i>
      </router-link>
      <el-col :span="6" class="whiteBg">
        <span class="InquiryConditionSpan">原文利実績：照会条件設定</span>
      </el-col>
      <el-col :span="12">
        <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <el-row class="InquiryConditionBody">
      <el-form ref="form" :model="form" :rules="rules" label-width="auto">
        <el-form-item label="集計条件" class="userGroup_leftallign">
          <!-- Change CK for Backlog-comment:1592 changed usergroubid to usergroupname -->
          <span>ユーザグループID {{ userGroupName }} (ユーザID：{{ userId }})</span>
        </el-form-item>
        <el-form-item label="集計期間" class="Aggregation__period" prop="range">
          <!-- <el-input v-model="form.name"></el-input> -->
          <v-date-picker mode="range" :input-props = "{readonly: true}" :masks="{ title: 'YYYY年MMM' }" v-model="form.range" locale="ja" show-caps class="SelectDateRangeInq" />
        </el-form-item>
        <!-- <router-link to="/sp/0016" class="Router__To__Destination" tabindex="1"> -->
        <el-button type="primary" plain class="submit__btn" @click="goto0015('form')">照会</el-button>
        <!-- </router-link> -->
      </el-form>
    </el-row>
  </section>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import router from '../../router';
import VCalendar from "v-calendar-ie11";
//import Common from '../../common/CommonFunc.js';
// import Vue from 'vue';
Vue.use(VCalendar);

var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();
var EndDay = 0;
var StartDay = 0;  
var PreviousMonth;

var Month;
//if current date is 01, start date is first date of previous month and end date is last date of previous month
//if current date is 01, start date is first date of previous month and end date is last date of previous month
if(CurrentDay == 1)
{
    StartDay = 1;
    PreviousMonth = CurrentMonth - 1;
    EndDay = 0;
    Month = CurrentMonth;
    //CurrentMonth = CurrentMonth - 1;
}
else
{
    //else start date is first date of previous month and end date is first date of current month
    StartDay = 1;
    EndDay = CurrentDay - 1;
    PreviousMonth = CurrentMonth;
    Month = CurrentMonth;
}
export default {
  name: "InquiryCondition0014",
  props: [],
  mounted() {
    this.userId = this.getUserId;
    this.userGroupId = this.getUserGroupId
    this.userGroupName = this.getUserGroupName
    this.$store.commit('sp_Situation0001/setThemeLoadCheck', 0);
  },
  data() {
    var checkdate = (rule, value, callback) => {
		var date_select = this.form.range.start;
		var todaydate=new Date();
		if (date_select > todaydate) {
			callback(new Error("集計期間は正しい日付を入力してください。"));
		} else {
			callback();
		}
		};
    return {
      userGroupId: '',
      userId: '',
      userGroupName:'',
      
      form: {
        name: "",
        range: {
          //start: new Date(2020, 2, FifteendaysBefore), // Jan 16th, 2018
					start: new Date(CurrentYear, PreviousMonth, StartDay), // Jan 16th, 2018
					end: new Date(CurrentYear, Month, EndDay) // Jan 19th, 2018
        },
      },
      rules: {
             range: [
            { required: true, message: '集計期間を指定してください。', trigger: 'blur'},
            { validator:checkdate,message:'集計期間は正しい日付を入力してください。', trigger: 'change'}
            ]
        }
    };
  },
  methods: {
    
    goto0015 (formName) {
this.$LogButtonEvent("0014","Inquiry");
this.$LogMethodIN("0014","goto0015"); 
      this.$refs[formName].validate((valid) => {
					if(valid)
					{
						var aggregation_period_date=this.form.range;
						console.log(aggregation_period_date)
						//To get the start date
						var getStartDate=aggregation_period_date.start;
							var splitData = new Date(getStartDate),
							splitmonth = ("0" + (splitData.getMonth() + 1)).slice(-2),
							splitday = ("0" + splitData.getDate()).slice(-2);
							var startResult = [splitData.getFullYear(), splitmonth, splitday].join("/");
							console.log(startResult);
						//To get the end date
						var getlastDate=aggregation_period_date.end;
						var splitDataLast = new Date(getlastDate),
						splitmonthlast = ("0" + (splitDataLast.getMonth() + 1)).slice(-2),
						splitdaylast = ("0" + splitDataLast.getDate()).slice(-2);
						var endResultlast = [splitDataLast.getFullYear(), splitmonthlast, splitdaylast].join("/");
						console.log(endResultlast);
						var sent_data={
							AggregationconditionUser_group:this.userGroupId,
							AggregationconditionUser_id:this.userId,
							startDate:startResult,
							endDate:endResultlast

						}
						router.push({
						name: "sp_0015",
						params: {
							data:sent_data
							}
						});
           
						
					}
					else
					{
						
						return false;
          }});
          this.$LogMethodOut("0014","goto0015");
    }
  },
  computed: {
		...mapGetters("sp_ValidationHandler", [
			"getRules",
    ]),
    ...mapGetters("sp_Situation0014", [
			"getUserGroupId",
			"getUserId",
      "getinput"
    ]),
    ...mapGetters("situation0001", [     
            "getUserId",
            "getUserGroupId",
            "getUserGroupName"
        ])
    },
    beforeCreate(){
      //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
      //Common.Session.CheckIsMobile("/sp/0014","/0014"); // MobileScreen Path, WebScreen Path
 }
};
</script>
<style scoped>
 @import "0014.css";
 @import "../../assets/css/customStyle.css"; 
</style>